import * as React from 'react'

const SvgZoomInIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.875 8.125h-2.5v-2.5h-1.25v2.5h-2.5v1.25h2.5v2.5h1.25v-2.5h2.5v-1.25zm2.156 5a6.793 6.793 0 001.594-4.375 6.875 6.875 0 10-6.875 6.875c1.6 0 3.15-.564 4.375-1.594l4.744 4.719.881-.881-4.719-4.744zm-5.281 1.25a5.625 5.625 0 110-11.25 5.625 5.625 0 010 11.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgZoomInIcon
